/** Client-only ownership for progress whose clicked link leaves the tree (for
 * example a mobile menu closing). Only ephemeral UI ownership; never persisted or logged. */
export const NAVIGATION_PROGRESS_DELAY_MS = 250;
export type NavigationProgressHandoff = { owner: symbol; sourceUrl: string; startedAt: number };
let owner: symbol | null = null;
let handoff: NavigationProgressHandoff | null = null;
const listeners = new Set<() => void>();
const emit = () => { for (const listener of [...listeners]) listener(); };
export const navigationProgressSnapshot = () => handoff;
export const navigationProgressServerSnapshot = () => null;
export function subscribeNavigationProgress(listener: () => void) {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}
export function clearNavigationProgressHandoff() {
  owner = null;
  if (handoff) { handoff = null; emit(); }
}
export function beginNavigationProgressHandoff() {
  const token = Symbol();
  owner = token;
  handoff = { owner: token, sourceUrl: window.location.href, startedAt: Date.now() };
  emit();
}
export function claimNavigationProgress(nextOwner: symbol) {
  owner = nextOwner;
  if (handoff) { handoff = null; emit(); }
}
export function handOffNavigationProgress(value: NavigationProgressHandoff) {
  if (owner !== value.owner || window.location.href !== value.sourceUrl) return;
  handoff = value;
  emit();
}
export function releaseNavigationProgress(previousOwner: symbol) {
  if (owner === previousOwner) clearNavigationProgressHandoff();
}
